import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Vector 7175",
      d: "M8.53594 1.03716L1.46406 8.10741M1.46406 1.03716L8.53594 8.10741",
      stroke: "#BB5332",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }